import { useState, useEffect } from "react";
import { getPage, type CmsPage } from "@/services/pages";

export type CmsStatus = "loading" | "ready" | "missing";

export function useCmsPage(slug: string): { page: CmsPage | null; status: CmsStatus } {
  const [page, setPage] = useState<CmsPage | null>(null);
  const [status, setStatus] = useState<CmsStatus>("loading");

  useEffect(() => {
    let active = true;
    setStatus("loading");
    setPage(null);
    getPage(slug)
      .then((p) => {
        if (!active) return;
        setPage(p);
        setStatus("ready");
      })
      .catch(() => {
        if (!active) return;
        setPage(null);
        setStatus("missing");
      });
    return () => {
      active = false;
    };
  }, [slug]);

  return { page, status };
}